import { render, staticRenderFns } from "./HeroSection.vue?vue&type=template&id=6b637ef6&"
import script from "./HeroSection.vue?vue&type=script&lang=ts&"
export * from "./HeroSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports